import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPin = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M4.17 9.94625L0.808129 13.3081C0.563754 13.5525 0.563754 13.9475 0.808129 14.1919C0.930004 14.3138 1.09 14.375 1.25 14.375C1.41 14.375 1.57 14.3138 1.69188 14.1919L5.05375 10.83L4.17 9.94625Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M14.8169 4.55812L10.4419 0.183125C10.1975 -0.0612502 9.8025 -0.0612502 9.55813 0.183125C9.31375 0.4275 9.31375 0.8225 9.55813 1.06687L10.1256 1.63437L3.2375 5.47875L2.31688 4.55812C2.0725 4.31375 1.6775 4.31375 1.43313 4.55812C1.18875 4.8025 1.18875 5.1975 1.43313 5.44187L9.55813 13.5669C9.68 13.6887 9.84 13.75 10 13.75C10.16 13.75 10.32 13.6887 10.4419 13.5669C10.6863 13.3225 10.6863 12.9275 10.4419 12.6831L9.52125 11.7625L13.3656 4.87437L13.9331 5.44187C14.055 5.56375 14.215 5.625 14.375 5.625C14.535 5.625 14.695 5.56375 14.8169 5.44187C15.0613 5.1975 15.0613 4.8025 14.8169 4.55812Z",
			fill: "currentColor"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "white"
		})
	}) })]
});
export default SvgIconPin;
